import { Navigate } from "react-router-dom";
import { usePermissions } from "../context/Permissioncontext";
import { readUserFromStorage } from "../utils/planningAccess";
import { isCoachViewForTraining } from "../utils/trainingRoomAccess";

/**
 * Redirects to /training when the active Home role is Player (dual-role safe).
 */
export function CoachExerciseControlRoute({ children }) {
  const { permissions } = usePermissions();
  const user = readUserFromStorage();
  if (!isCoachViewForTraining(user, permissions)) {
    return <Navigate to="/training" replace />;
  }
  return children;
}

export default CoachExerciseControlRoute;
